import type { ForgotPasswordConfig } from '#types/config/components/form/forgotPassword'

export default {
  brandClasses: {
    form: 'mt-4',
    heading: 'subtitle-1',
    submitButton: 'mt-6 <md:w-full',
  }
} satisfies ForgotPasswordConfig
